import { jwtDecode } from 'jwt-decode';

const jwtDecoder = (token) => {
    const decodedValue = jwtDecode(token)
    return decodedValue;
}

export default jwtDecoder;